module.exports = __webpack_public_path__ + "static/img/float_icon_b.83c97a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/float_icon_b.png
// module id = GyMa
// module chunks = 78